
import { take, all, call, put } from 'redux-saga/effects'
import * as api from '../services/api'
import HOOK from "../components/hooks"
import { nexusDataPrep } from '../modules/nexusDataPrep'
import { committeesDataPrep } from '../modules/committeesDataPrep'
import analyseNodes from '../modules/analyseNodes'
import { updateNexusD3 } from '../pages/companiesHouse/nexus/nexusD3'
import { updateTimelineD3 } from '../pages/companiesHouse/nexus/timelineD3'
import { getNameProp, notEmpty, stringMatch } from "../modules/utilities"
import { BASE, CATEGORY, JARGON, RADIO, STATUS, TENSE_ENUM, VIEW } from '../modules/constants'
import { CHECKBOX } from '../modules/checkbox_constants'
import { getChecked } from "../../app/pages/companiesHouse/pageFunctions/checkboxFunctions"
import { getFilteredItems } from "../components/layout/NexusTable/GetFilteredItems"
import { getEntityById, getEntityByLei, mergeIds, processNewEntities, setIsFavourite } from '../modules/nexusFuncs'

const initData = () => ({
  hubId: "",
  nodes: [],
  committeesNodes: [],
})

const initEntities = () => ({
  items: [],
  connections: {},
  pointers: {},
})

const local = {
  checkboxes: CHECKBOX.DEFAULT,
  location: {},
}

const initialState = {
  showErrorModal: false,
  showProgressModal: false,
  statusCode: 200,
  previousUrl: "/",
  data: initData(),
  entities: initEntities(),
  cancelGetScndLvl: false,
  status: STATUS.NEXUS.CLEAR,
  companyData: null,
}

export function reducer(state = initialState, action) {

  switch (action.type) {

    case 'nexus.initData': {
      // console.log(`initData action: `, action)
      return {
        ...state,
        data: initData(),
        entities: initEntities(),
      }
    }

    case 'nexus.setShowErrorModal': {
      // console.log(`nexus.setShowErrorModal action: `, action)
      return {
        ...state,
        customReason: action.customReason,
        reasonPhrase: action.reasonPhrase,
        showErrorModal: action.statusCode !== 200,
        statusCode: action.statusCode,
        status: STATUS.NEXUS.CLEAR,
      }
    }

    case 'nexus.saveEntities': {
      // console.log(`nexus.saveEntities: action: `, action)
      return {
        ...state,
        entities: action.entities,
        data: action.data,
        previousUrl: action.match.url,
        cancelGetScndLvl: false,
        status: STATUS.NEXUS.CLEAR,
        totalResults: action.totalResults
      }
    }

    case 'nexus.saveEntities2': {
      // console.log(`nexus.saveEntities2 action: `, action)
      return {
        ...state,
        entities: action.entities,
      }
    }

    case 'nexus.saveTotalResults': {
      // console.log(`nexus.saveTotalResults action: `, action)
      return {
        ...state,
        totalResults: action.totalResults
      }
    }

    // TODO: Rename instateCancellation??
    case 'nexus.saveSettings': {
      // console.log('nexus.saveSettings action:', action)
      local.checkboxes = action.checkboxes
      return {
        ...state,
        showProgressModal: false,
        cancelGetScndLvl: action.cancelGetScndLvl === true,
      }
    }

    case 'nexus.setShowProgressModal': {
      // console.log('nexus.setShowProgressModal:', action)
      return {
        ...state,
        showProgressModal: action.show,
      }
    }

    case 'nexus.getEntities': {
      // console.log('nexus.getEntities:', action)
      // Set local.checkboxes so that the ..
      local.checkboxes = action.checkboxes
      return {
        ...state,
        status: action.status,
      }
    }

    case 'nexus.setStatus': {
      console.log('nexus.setStatus:', action)
      return {
        ...state,
        status: action.status,
      }
    }

    case 'nexus.setSkeleton': {
      // console.log('nexus.setSkeleton:', action)
      return {
        ...state,
        skeleton: action.skeleton,
      }
    }

    default: {
      return state
    }
  }
}

function* watchCancelGetEntities() {
  while (true) {
    const props = yield take('nexus.cancelGetEntities')
    // console.log('cancelGetEntities props: ', props)
    yield put(actions.updateNexusData({ ...props }))
  }
}

function* watchGetEntities() {

  let uriId
  let entity
  let totalResults

  let newEntities = {
    items: [],
    connections: [],
  }

  while (true) {
    let httpResponseMessage = { statusCode: 200 }

    const props = yield take('nexus.getEntities')

    var { idsList, entities, favourites, features } = props
    // console.log(`watchGetEntities: `, props)
    totalResults = 0

    for (var index = 0; index < idsList.length; index++) {
      uriId = idsList[index]

      entity = getEntityById(entities, uriId.split(","))
      // console.log('entity:', entity)

      let ids = separateIds(uriId)

      if (ids.lei) {
        // Get the local entity if we have alredy aquired it
        var companyEntity = getEntityByLei(entities, ids.lei)

        if (companyEntity?.profile !== true) {
          try {
            newEntities = yield call(api.entities.getProfileEntity, ids.lei)
            // console.log('newEntities:', newEntities)
            httpResponseMessage = newEntities.httpResponseMessage
            if (httpResponseMessage.statusCode === 200) {
              processNewEntities(entities, newEntities, uriId, favourites)

              if (companyEntity === undefined)
                companyEntity = getEntityById(entities, [newEntities.companyNumber])
              // companyEntity = getEntityById(entities, [companyNumber])
            }

            // The profile flag tell us we have acquired the profile, officers & pscs for this company
            companyEntity.profile = true
            // The acquired flag tell us we have acquired the profile, officers & pscs for this company
            companyEntity.acquired = true
          }
          catch (e) {
            console.log('e:', e)
            // httpResponseMessage = JSON.parse(e.message)
            // console.log('httpResponseMessage', httpResponseMessage)
          }
        }
      } else
        for (var companyNumber of ids.companyNumbers) {
          var companyEntity = getEntityById(entities, [companyNumber])

          // Note: The company entity will exist, but not been 'acquired'
          // only if it has been added as an officer's appointment
          if (companyEntity === undefined || companyEntity.profile !== true) {
            try {
              newEntities = yield call(api.entities.getProfileEntity, companyNumber)
              // console.log(`getProfileEntity - newEntities: `, newEntities)

              httpResponseMessage = newEntities.httpResponseMessage

              if (httpResponseMessage.statusCode === 200) {
                processNewEntities(entities, newEntities, uriId, favourites)

                if (companyEntity === undefined)
                  companyEntity = getEntityById(entities, [companyNumber])

                // If we get lse from mongo, we already have the officers (items.length > 1)
                if (newEntities.items.length === 1) {
                  const { companyProfile } = companyEntity.companyProps

                  // Remove psc links if user does not have 'standard' features
                  if (!features.PSCs)
                    removePscLinks(companyProfile)

                  const { companyStatusEnum, dateOfCessation, dateOfCreation, links } = companyProfile
                  newEntities = yield call(api.entities.getCompanyEntities, companyNumber, links, companyStatusEnum, dateOfCreation, dateOfCessation)
                  // console.log(`getCompanyEntities - newEntities: `, newEntities)
                  httpResponseMessage = newEntities.httpResponseMessage

                  if (httpResponseMessage.statusCode === 200)
                    processNewEntities(entities, newEntities, uriId, favourites)
                }

                // The profile flag tell us we have acquired the profile, officers & pscs for this company
                companyEntity.profile = true
                // The acquired flag tell us we have acquired the profile, officers & pscs for this company
                companyEntity.acquired = true
              }
            }
            catch (e) {
              httpResponseMessage = JSON.parse(e.message)
              console.log('httpResponseMessage', httpResponseMessage)
            }
          }
        }

      if (ids.officerIds.length > 0) {
        if (entity === undefined || entity.appointments !== true) {
          try {
            newEntities = yield call(api.entities.getAppointmentEntities, ids.officerIds.join(), !!features.MaxLseData)
            // console.log(`getAppointmentEntities - newEntities: `, newEntities)
            totalResults = newEntities.totalResults
            httpResponseMessage = newEntities.httpResponseMessage

            if (httpResponseMessage.statusCode === 200) {
              processNewEntities(entities, newEntities, uriId, favourites)

              // If it wasn't already, the entity should now exist
              if (entity === undefined)
                entity = getEntityById(entities, uriId.split(","))

              entity.appointments = true
              entity.acquired = true

            } else { // Get get appointments gave error
              if (entity !== undefined) {
                // We have basic officer info (from get officers), but get officer failed
                // Note: Only give error if this is the hub (index 0)

                // Set pageNotFound whether or not this is the hub, so we don't try
                // getting it again with subsequent 'get second level' call
                entity.pageNotFound = true

                if (index === 0) {
                  entity.appointments = true
                  entity.acquired = true
                  setCustomReason(httpResponseMessage, getNameProp.toPresent(entity.name))
                  yield put(actions.updateNexusData({ ...props }))
                } else {
                  // This is not the hub (we must be getting second level)
                  httpResponseMessage.statusCode = 200
                }
              }
            }
          }
          catch (e) {
            httpResponseMessage = JSON.parse(e.message)
            console.log('httpResponseMessage', httpResponseMessage)
          }
        }
      } else
        if (ids.pscIds.length && idsList.length > 1) {
          // This is a PSC and not officer. Since we can get no more data
          // on this entity we must set acquired to true - otherwise
          // we will continuously try to get this when getting second level
          getEntityById(entities, idsList[1].split(",")).acquired = true
        }
    }

    // Only continue if everything is OK
    if (httpResponseMessage.statusCode === 200) {
      var hubEntity = getEntity(entities, idsList[0])

      if (hubEntity.category === CATEGORY.COMPANY && hubEntity.profile === false) {
        // This should only occur for company psc/officer
        // console.log('hubEntity.profile === false :', hubEntity)
        yield put(actions.getCompany({ ...props, hubEntity, companyName: hubEntity.name.original, favourites, totalResults }))
      } else {
        if (notEmpty(favourites))
          setIsFavourite(hubEntity, favourites)

        yield put(actions.updateNexusData({ ...props, totalResults }))
      }
    }
    else
      yield put(actions.setShowErrorModal(httpResponseMessage))
  }
}

function* watchGetCompany() {
  // Acquires a company that we know only by name (not number)
  // using search followed by getProfileEntity and getCompanyEntities
  // Used when the hub entity is a corporate officer or pc
  while (true) {
    var httpResponseMessage = { statusCode: 200 }
    var newEntities = {}
    var searchResults = {}
    var companyEntity
    var companyNumber
    var topResult

    const props = yield take('nexus.getCompany')
    // console.log('nexus.getCompany props:', props)

    var { uriId, entities, hubEntity, companyName, favourites, totalResults } = props

    // search for a company by name
    searchResults = yield call(api.companiesHouse.search, { scope: "companies", searchString: companyName })

    // console.log('searchResults:', searchResults)
    if (searchResults.items.length > 0) {

      topResult = searchResults.items[0]

      if (stringMatch(topResult.title, companyName)) {

        companyNumber = topResult.companyNumber

        // get the company profile
        newEntities = yield call(api.entities.getProfileEntity, companyNumber)
        // console.log('nexus.getCompany newEntities:', newEntities)
        httpResponseMessage = newEntities.httpResponseMessage

        if (httpResponseMessage.statusCode === 200) {

          companyEntity = newEntities.items[0]
          companyEntity.ids = mergeIds(companyEntity.ids, hubEntity.ids)
          // console.log('newEntity:', companyEntity)

          processNewEntities(entities, newEntities, uriId, favourites)

          if (httpResponseMessage.statusCode === 200) {

            const { companyProfile } = companyEntity.companyProps

            newEntities = yield call(api.entities.getCompanyEntities, companyNumber, companyProfile.links, companyProfile.companyStatusEnum, companyProfile.dateOfCreation, companyProfile.dateOfCessation)

            // console.log(`getCompanyEntities - newEntities: `, newEntities)
            httpResponseMessage = newEntities.httpResponseMessage

            if (httpResponseMessage.statusCode === 200) {
              totalResults += newEntities.totalResults
              processNewEntities(entities, newEntities, uriId, favourites)
            }
          }
        }
      }
    }

    if (notEmpty(favourites))
      setIsFavourite(hubEntity, favourites)

    // Only continue if everything is OK
    if (httpResponseMessage.statusCode === 200)
      yield put(actions.updateNexusData({ ...props, totalResults }))
    else
      yield put(actions.setShowErrorModal(httpResponseMessage))
  }
}

const removePscLinks = companyProfile => {
  // console.log('companyProfile:', companyProfile)
  companyProfile.links.personsWithSignificantControl = null
}

const getEntity = (entities, uriId) => {
  const lei = getLeiFromString(uriId)
  return lei
    ? getEntityByLei(entities, lei)
    : getEntityById(entities, uriId.split(","))
}

function* watchUpdateNexusData() {
  while (true) {
    const props = yield take('nexus.updateNexusData')
    var { checkboxes, entities, uriId, nexusView, nexusData, radio } = props
    // console.log("updateNexusData props", props)

    const hubEntity = getEntity(entities, uriId)
    const isCompany = entities.items[hubEntity.entityId].category === CATEGORY.COMPANY
    const showPast = !!(CHECKBOX[HOOK.TENSE][TENSE_ENUM.PAST].BIT & checkboxes[HOOK.TENSE])
    const tense = getChecked({ checkboxes, hook: [HOOK.TENSE] })
    const enableSecondLevel = isCompany
      ? radio[BASE.COMPANY] === RADIO[BASE.COMPANY].CONNECTIONS
      : radio[BASE.PERSON] === RADIO[BASE.PERSON].CONNECTIONS
    const showNonOverlapping = false // !!BITWISE.and(CHECKBOX[HOOK.CONNECTIONS][1].BIT, checkboxes)

    let data = getData({ ...props, enableSecondLevel, hubEntity, showNonOverlapping, showPast, tense })
    // console.log('data:', data)
    data.showPast = showPast
    data.enableSecondLevel = enableSecondLevel

    // If we have cancelled the get second level checkboxes will have the value
    // set prior to cancelling, whereas local.checkboxes is the most up to date value.
    // Cancelling will have updated the D3 while waiting for a response from backend.
    // We don't want to use any new entities, but do want to save them - below.
    // console.log("data: ", data)
    if (local.checkboxes === checkboxes && nexusData.nodes.length > 0) {
      if (nexusView === VIEW.D3)
        updateNexusD3({ ...props, data })
      else if (nexusView === VIEW.TIMELINE) {
        // console.log('entities.items[hubEntity.entityId]:', entities.items[hubEntity.entityId])
        const tableProps = {
          checkboxes,
          connections: entities.connections,
          items: data.nodes,
          showSecondDegree: enableSecondLevel, // *****
          isCompany,
          maxLseData: props.features.MaxLseData,
        }
        // console.log('tableProps:',tableProps)
        var filteredItems = getFilteredItems(tableProps)
        // console.log('items:', filteredItems)
        updateTimelineD3({ ...props, data, filteredItems })
      }
    }

    // console.log('props.location:',props.location)
    yield put(actions.saveEntities({ ...props, data, entities }))
  }
}

function* watchSetEntityIsFavourite() {
  // If the entity with supplied id exists, sets the isFavourite flag of that entity
  while (true) {
    const { entities, id, isFavourite } = yield take('nexus.setEntityIsFavourite')
    let entity = getEntityById(entities, [id])
    if (entity !== undefined) {
      entity.isFavourite = isFavourite
      yield put(actions.saveEntities2(entities))
    }
  }
}

const setCustomReason = (httpResponseMessage, name) => httpResponseMessage.customReason =
  `${JARGON.APPT} information for ${name} is currently unavailable from Companies House`

const getData = props => {
  // console.log("getData")
  const { entities, hubEntity, uriId, tense } = props
  const hubId = hubEntity.entityId
  const { nodes, levelCount } = nexusDataPrep.getConnectedNodes({ ...props, hubId })
  const { committeesNodes, zeroCommitteeNodes } = committeesDataPrep.getConnectedNodes({ ...props, hubId })
  const { connections } = entities
  const links = analyseNodes.setLinks({ ...props, hubId, nodes, connections })

  // NB: We don't need links for committees
  analyseNodes.setLinks({ ...props, hubId, nodes: committeesNodes, connections })

  // sort be level, to ensure that hub node is [0], first in array
  nexusDataPrep.sortNodes({ nodes, levelCount, tense })

  return {
    category: hubEntity.category,
    hubId,
    chId: uriId,
    nodes,
    committeesNodes,
    levelCount,
    links,
    zeroCommitteeNodes,
  }
}

const separateIds = uriId => {
  // UK company number 8 chars eg 01142830
  // CH officerId 27 chars eg 5LLFgJeOHxGYOH33SOfYzdEuvHo
  // GUID 32 chars eg 3267c1c0aa-52c2-4255-bdb1-2bcf58254545
  // PSC 8 + 1 + 27 chars eg. 09741232@N0i1l6VD4XaOu30oiPh8PDEWxwA

  let ids = uriId.split(",")
  let lei = getLeiFromString(ids)
  let companyNumber = ids.find(id => id.length < 25) // TODO Constant??
  let officerIds = ids.filter(id => !id.includes("@") && id.length > 24)
  let pscIds = ids.filter(id => id.includes("@"))
  let companyNumbers = pscIds.map(pscId => pscId.split("@")[0])

  if (companyNumber !== undefined)
    companyNumbers.push(companyNumber)

  return {
    companyNumber,
    companyNumbers,
    lei,
    officerIds,
    pscIds,
  }
}

const leiRegex = new RegExp("^[A-Z0-9]{18}[0-9]{2}$")
const getLeiFromString = string => {
  const array = leiRegex.exec(string)
  return array ? array[0] : null
}

export const actions = {
  initData: () =>
    ({ type: 'nexus.initData' }),
  getEntities: props =>
    ({ ...props, type: 'nexus.getEntities' }),
  cancelGetEntities: props =>
    ({ ...props, type: 'nexus.cancelGetEntities' }),
  saveEntities: props =>
    ({ ...props, type: 'nexus.saveEntities' }),
  saveEntities2: entities =>
    ({ type: 'nexus.saveEntities2', entities }),
  setShowErrorModal: props =>
    ({ ...props, type: 'nexus.setShowErrorModal' }),
  updateNexusData: props =>
    ({ ...props, type: 'nexus.updateNexusData' }),
  getCompany: props =>
    ({ ...props, type: 'nexus.getCompany' }),
  saveTotalResults: props =>
    ({ ...props, type: 'nexus.saveTotalResults' }),
  saveSettings: props =>
    ({ ...props, type: 'nexus.saveSettings' }),
  setEntityIsFavourite: (entities, id, isFavourite) =>
    ({ type: 'nexus.setEntityIsFavourite', entities, id, isFavourite }),
  setShowProgressModal: show =>
    ({ type: 'nexus.setShowProgressModal', show }),
  setStatus: status =>
    ({ type: 'nexus.setStatus', status }),
  setSkeleton: skeleton =>
    ({ type: 'nexus.setSkeleton', skeleton }), // save basic info when selecting search or favourite
}

export const selectors = {
}

export function* sagas() {
  yield all([
    watchCancelGetEntities(),
    watchGetEntities(),
    watchUpdateNexusData(),
    watchGetCompany(),
    watchSetEntityIsFavourite(),
  ])
}

